<template>
  <div>
    <!-- Preloader Start -->
    <div id="preloader-active">
      <div class="preloader d-flex align-items-center justify-content-center">
        <div class="preloader-inner position-relative">
          <div class="preloader-circle"></div>
          <div class="preloader-img pere-text">
            <img src="/assets/img/logo/logo.png" alt />
          </div>
        </div>
      </div>
    </div>
    <!-- Preloader Start -->

    <header>
      <!-- Header Start -->
      <div class="header-area header-transparrent">
        <div class="main-header header-sticky">
          <div class="container">
            <div class="row align-items-center">
              <!-- Logo -->
              <div class="col-xl-2 col-lg-2 col-md-2">
                <div class="logo">
                  <a href="/">
                    <img
                      src="/assets/img/logo/logo.png"
                      style="margin-top: 1.1em; margin-bottom: 1.1em;"
                      height="60px"
                      alt
                    />
                  </a>
                </div>
              </div>
              <div class="col-xl-10 col-lg-10 col-md-10">
                <!-- Main-menu -->
                <div class="main-menu f-right d-none d-lg-block">
                  <nav>
                    <ul id="navigation">
                      <li class="active">
                        <router-link to="/">Home</router-link>
                      </li>

                      <li>
                        <router-link to="/web/contact">Contact</router-link>
                      </li>
                      <li>
                        <router-link to="/web/forgot">Forgot Password</router-link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <!-- Mobile Menu -->
              <div class="col-12">
                <div class="mobile_menu d-block d-lg-none"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Header End -->
    </header>
  </div>
</template>

<script>
export default {
  mounted() {
    $("#preloader-active")
      .delay(450)
      .fadeOut("slow");
    $("body")
      .delay(450)
      .css({
        overflow: "visible"
      });
  }
};
</script>

<style>
</style>
